import { Accordion, AccordionItem } from "@heroui/react";
import { MinusIcon, PlusIcon } from "lucide-react";
import { useState } from "react";

const KeySectors = () => {
	const keySectors = [
		{
			title: "Energy",
			content:
				"The Energy sector focuses on transitioning to renewable energy, improving energy efficiency, and adopting clean technologies to significantly reduce greenhouse gas (GHG) emissions. This includes projects such as solar, wind, hydro power, and other energy-saving initiatives, all of which play a critical role in achieving sustainable development goals and combating climate change.",
			image: "sector-energy-sm.jpg",
			value: "1",
		},
		{
			title: "Industrial Processing and Product Use (IPPU)",
			content:
				"IPPU projects aim to reduce emissions from industrial activities, such as cement production, chemical manufacturing, and refrigerant use, by enhancing efficiency and promoting low-carbon industrial practices. These initiatives align with global and national climate goals, contributing to high-integrity outcomes that support sustainable development.",
			image: "sector-ippu-sm.jpg",
			value: "2",
		},
		{
			title: "Agriculture",
			content:
				"The agriculture sector focuses on reducing methane and nitrous oxide emissions from farming. This includes climate-smart agricultural practices, organic farming, and improved livestock management to enhance sustainability.",
			image: "sector-agriculture-sm.jpg",
			value: "3",
		},
		{
			title: "Forestry and Other Land Use (FOLU)",
			content:
				"Avoid deforestation and forest degradation, while strategically expanding forest cover through reforestation and afforestation efforts. Additionally, prioritize the conservation and sustainable management of remaining forests to ensure their integrity and biodiversity.",
			image: "sector-forest.jpg",
			value: "4",
		},
		{
			title: "Waste Management",
			content:
				"Enhance waste management through improved management (reduce, recycling, upcycling, reducing open burning, waste-to-energy. Strengthen waste collection, address plastic waste strategy through 4R framework. to improve the management of industrial, medical, and other hazardous waste, as segregation at the source is currently insufficient. Recent government crackdowns on companies illegally discharging harmful waste demonstrate a firm stance on pollution.",
			image: "sector-waste-sm.jpg",
			value: "5",
		},
	];

	const [activeKey, setActiveKey] = useState("0");

	const handleAccordionChange = (key: string) => {
		setActiveKey((prevKey) => (prevKey === key ? prevKey : key));
	};

	const [activeImage, setActiveImage] = useState(keySectors[0].image);

	return (
		<div className="py-5 md:py-10 px-5 xl:px-0">
			<div className="container mx-auto max-w-7xl">
				<div className="space-y-1 md:space-y-14">
					<div className="space-y-1 p-4 sm:p-0">
						<p className="text-2xl md:text-3xl">EXPLORE</p>
						<p className="text-4xl md:text-5xl font-bold text-primary">
							Key Sectors
						</p>
						<p className="text-2xl md:text-3xl">for Climate Impact</p>
					</div>
					<div className="grid md:flex flex-row-reverse gap-0 md:gap-6  ">
						<div className="flex-[3] p-4 sm:p-0">
							<Accordion
								dividerProps={{ hidden: true }}
								selectedKeys={[activeKey]}
							>
								{keySectors.map((item, index) => {
									const key = String(index);
									const isActive = activeKey === key;
									return (
										<AccordionItem
											key={index}
											value={index}
											title={item?.title}
											classNames={{
												indicator: "data-[open=true]:-rotate-0 ",
												title: `text-xl data-[open=true]:font-bold ${
													isActive ? "cursor-default" : "cursor-pointer"
												}`,
												content: `py-0 pb-4`,
											}}
											indicator={({ isOpen }) =>
												isOpen ? <MinusIcon /> : <PlusIcon />
											}
											onPress={() => {
												handleAccordionChange(index.toString());
												setActiveImage(item.image); // Update image
											}}
										>
											<div className="flex flex-col gap-4">
												<p>{item?.content}</p>
												<a
													href={`/projects?page=1&limit=12&sector=${item?.value}`}
													className="text-primary"
												>
													View Projects
												</a>
											</div>
										</AccordionItem>
									);
								})}
							</Accordion>
						</div>
						<div className="flex-1 md:flex-[2] p-4 md:p-0">
							<img
								className="w-full h-[500px] rounded-2xl object-cover transition-all duration-500"
								src={activeImage}
								alt="Key Sector"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default KeySectors;
